package ui.campaign.detailv2.editor.page

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import compose.assets.Svg
import compose.assets.svg.Chat_question
import org.ssoft.common.type.ScreenRatio
import ssoft.frontend.generated.resources.*
import tools.rememberString
import ui.campaign.detailv2.editor.CampaignEditorScope
import ui.campaign.detailv2.editor.NextButton
import ui.campaign.detailv2.editor.wrapper.CampaignWrapperE
import ui.campaign.detailv2.editor.wrapper.CampaignWrapperEOffsets
import ui.campaign.labelRes
import ui.widget.DialogState
import ui.widget.LazyImage
import ui.widget.TooltipDialog

@Composable
fun CampaignEditorScope.CampaignPage03Offsets(nnvl: CampaignWrapperE) {
    LazyColumn(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.spacedBy(8.dp),
        contentPadding =
            if (display.isMobileOrSmall) PaddingValues(0.dp, 8.dp, 0.dp, 8.dp)
            else PaddingValues(16.dp)
    ) {
        item {
            Title()
        }

        if (nnvl.offsets.adapter.state.size > 5) {
            item {
                NextButton(Res.string.layer_top_detail_editor__act_skip)
            }
        }

        nnvl.offsets.adapter.state.groupBy { it.state }
            .forEach { group ->
                stickyHeader {
                    Box(Modifier.fillMaxWidth()) {
                        Text(
                            text = group.key.labelRes().rememberString(),
                            style = MaterialTheme.typography.labelMedium,
                            modifier = Modifier.width(512.dp)
                                .align(Alignment.Center)
                                .background(MaterialTheme.colorScheme.background)
                                .padding(4.dp)
                        )
                    }
                }
                items(group.value) {
                    Item(it)
                }
            }

        item {
            NextButton()
        }
    }
}

@Composable
private fun CampaignEditorScope.Item(item: CampaignWrapperEOffsets.AdapterCampaigns.Item) {
    Box(Modifier.fillMaxWidth()) {
        Card(
            onClick = { item.excluded.set(!item.excluded.state) },
            modifier = Modifier.width(512.dp).align(Alignment.Center),
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.surfaceContainer
            )
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier.fillMaxWidth()
                    .padding(start = 8.dp)
            ) {
                Checkbox(
                    checked = !item.excluded.state,
                    modifier = Modifier.align(Alignment.CenterVertically),
                    onCheckedChange = { item.excluded.set(!it) })
                Text(
                    text = item.data.name,
                    maxLines = 2,
                    modifier = Modifier.weight(1F)
                        .align(Alignment.CenterVertically)
                )
                if (item.data.res.id > 0) {
                    val visualRatio = remember(item.data.res.ratio) {
                        ScreenRatio[item.data.res.ratio]
                    }
                    val modifier =
                        if (visualRatio.land) Modifier.width(128.dp)
                        else Modifier.width(64.dp)
                    LazyImage(
                        id = item.data.res.id,
                        alphaBackground = false,
                        modifier = modifier.aspectRatio(visualRatio.pair.first.toFloat() / visualRatio.pair.second.toFloat())
                    )
                }
            }
        }
    }
}

@Composable
private fun CampaignEditorScope.Title() {
    val tooltipState = DialogState.remember(key = "tooltip:campaign-offsets")

    Box(Modifier.fillMaxWidth()) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            modifier = Modifier
                .align(Alignment.Center)
                .clip(CardDefaults.shape)
                .clickable { tooltipState.show() }
                .padding(16.dp)) {
            Text(
                text = Res.string.layer_top_detail_editor__offsets_title.rememberString(),
                style = MaterialTheme.typography.headlineSmall
            )
            Icon(
                imageVector = Svg.Chat_question,
                contentDescription = null,
                modifier = Modifier.align(Alignment.CenterVertically)
            )
        }
    }
    TooltipDialog(
        state = tooltipState,
        title = Res.string.layer_top_detail_editor__offsets_tooltip_title,
        message = Res.string.layer_top_detail_editor__offsets_tooltip_msg
    )
}